import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '~/store/index';
import { Authority } from '~/types/enum';
import type { TOwnInfo } from './user.type';

/** getOwnInfo 尚未回寫前為 initial 占位（無 _id），此時 authority 為預設 CLIENT，不可當成無後台權限 */
export const isOwnInfoPlaceholderProfile = (ownInfo: TOwnInfo): boolean =>
  ownInfo._id === '';

export const getterIsValidLogin = createSelector(
  (state: RootState) => state.user.ownInfo,
  ownInfo => {
    if (!ownInfo) return false;
    const { authority } = ownInfo;
    if (authority === Authority.CLIENT) return false;
    return true;
  },
);

export const getterIsAdminValidLogin = createSelector(
  (state: RootState) => state.user.ownInfo,
  ownInfo => {
    if (!ownInfo) return false;
    const { authority } = ownInfo;
    if (authority === Authority.CLIENT || authority === Authority.TEACHER)
      return false;
    return true;
  },
);

export const getterOwnInfo = createSelector(
  (state: RootState) => state.user.ownInfo,
  ownInfo => ownInfo,
);
